import { Input, InputRef } from "antd";
import { useEffect, useRef, useCallback } from "react";

import type { CustomCellEditorProps } from "ag-grid-react";
import { INumberCellEditorParams } from "ag-grid-enterprise";

export default function NumberCellEditor({
  value,
  onValueChange,
  eventKey
}: CustomCellEditorProps) {
  const refInput = useRef<InputRef>(null);
  const updateValue = useCallback(
    (val: string) => {
      onValueChange(val === "" ? null : val);
    },
    [onValueChange]
  );

  useEffect(() => {
    let startValue;

    if (eventKey === "Backspace") {
      startValue = "";
    } else if (eventKey && eventKey.length === 1) {
      startValue = eventKey;
    } else {
      startValue = value;
    }
    if (startValue == null) {
      startValue = "";
    }

    updateValue(startValue);

    refInput.current?.focus();
  }, [eventKey, updateValue, value]);

  return (
    <div className="h-full flex items-end">
      <Input
        ref={refInput}
        autoFocus
        type="number"
        value={value}
        onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
        onChange={(event: any) => {
          updateValue(event.target.value.replace(/\D/g, ""));
        }}
        min="0"
      />
    </div>
  );
}

export const numberFilterParams = {
  filterOptions: ["equals", "greaterThan", "lessThan", "inRange", "blank"],
  maxNumConditions: 1
};

export const numberCellEditorParams = {
  step: 1,
  showStepperButtons: true,
  max: Number.MAX_SAFE_INTEGER
} as INumberCellEditorParams;
